import { ConsentStatusLabel } from "./ConsentStatusLabel.js";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ElevatedCard, NavLink, Stack, Subtitle1 } from "@myphx-engineering/phx-design-system";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/client/components/consent-list/ConsentListItem.tsx
const ConsentListItem = ({ id, status, document, handleClick }) => {
	const { t } = useTranslation("cons");
	const onClick = useCallback(() => handleClick(id), [id, handleClick]);
	return /* @__PURE__ */ jsx(ElevatedCard, { children: /* @__PURE__ */ jsxs(Stack, {
		gap: "xs",
		children: [
			/* @__PURE__ */ jsx(ConsentStatusLabel, { status }),
			/* @__PURE__ */ jsx(Stack, {
				gap: "xxxs",
				children: /* @__PURE__ */ jsx(Subtitle1, { children: document.title })
			}),
			/* @__PURE__ */ jsx(NavLink, {
				label: t("consentItem.review"),
				onClick,
				variant: "subtle"
			})
		]
	}) });
};

//#endregion
export { ConsentListItem };